import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 960px;
  width: 100%;
  background-color: #F8F8F8;
  min-height: 100vh;
  padding-bottom: 80px;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  padding: 8px;
  color: #333;
  display: flex;
  align-items: center;
`;

export const SlideContainer = styled.div`
  .capture {
    width: 25vw;
    height: 15vh;
    margin-right: 3vw;
  }
`;

export const ReturnContainer = styled.div`
  background-color: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #E5E5E5;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 20px;
  margin-left: 16px;
  margin-right: 16px;
  padding-bottom: 20px;

  .Info {
    margin-top: 0;
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
  }

  .InfoTitle {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: bold;
    color: #000;
    text-align: left;
  }
`;

export const ImageContainer = styled.div`
  margin-top: 20px;
  margin-left: 16px;

  .icon {
    font-size: 3em;
  }

  .Imgtitle {
    font-size: 0.8em;
    color: #BBBBBB;
  }
`;

export const Container1 = styled.div`
  display: flex;
`;

export const Container2 = styled.div`
  margin-top: 0;
  margin-left: 16px;
  margin-right: 16px;

  .caImg {
    margin-right: 3vw;
  }

  .cab {
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 10px;
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 12px;
    color: #ffffff;
    background-color: #5ABD8D;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
  }

  .caimg {
    margin-right: 3vw;
  }

  .capture {
    margin-top: 1vh;
    margin-left: 1vw;
    border-radius: 1vw;
  }
`;

export const CheckContainer = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 20px;
  background-color: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #E5E5E5;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

  .title {
    padding-top: 24px;
    padding-bottom: 16px;
    text-align: center;
  }

  .Info1 {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }

  .Info2 {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
  }

  .check1,
  .check2,
  .check3 {
    margin-top: 16px;
    margin-left: 24px;
    margin-right: 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }

  .check4 {
    margin-top: 16px;
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
  }

  .box1 {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #D0D0D0;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    flex-shrink: 0;
    background-color: #fff;

    &::after {
      content: '✓';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #D0D0D0;
      font-size: 14px;
      font-weight: bold;
    }

    &:checked {
      background-color: #5ABD8D;
      border-color: #5ABD8D;
    }

    &:checked::after {
      color: white;
    }
  }
`;

export const ReturnButton = styled.div`
  margin-top: 20px;
  margin-bottom: 80px;
  margin-left: 16px;
  margin-right: 16px;
  height: 56px;
  background-color: #1FBC70;
  color: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #17a661;
  }
`;
